import { render } from "./SystempaySmartForm.vue?vue&type=template&id=1241c596"
import script from "./SystempaySmartForm.vue?vue&type=script&lang=js"
export * from "./SystempaySmartForm.vue?vue&type=script&lang=js"

import "./SystempaySmartForm.vue?vue&type=style&index=0&id=1241c596&lang=css"
script.render = render

export default script